import { render } from "./appbar.vue?vue&type=template&id=58abcb50"
import script from "./appbar.vue?vue&type=script&lang=js"
export * from "./appbar.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__